<template>

    <TsCardOpinionProduct :bannerImage="`${background.desktopBannerImage}?format=webp`"
        :imgMobile="`${background.mobileBannerImage}?format=webp`" frontClass="-mt-[55px] lg:-mt-[137px] w-full mx-auto"
        backClass="max-sm:px-4 bg-transparent">
        <template #front>
            <div  ref="carouselBlackFridayRef" class="lg:px-[18px]">
                <TsCarouselSale :navigation="!isMobile" :data-testid="'home-highlights-card-carousel'" :data="products"/>
            </div>
        </template>
    </TsCardOpinionProduct>

</template>

<script setup lang="ts">
import { ProductService } from '~/services/product.service';
import {onMounted, ref} from "vue";

const { isMobile } = useDevice();

const products = ref()

const carouselBlackFridayRef = ref('')

const TsCardOpinionProduct = defineAsyncComponent(
    () => import('~/components/organisms/TsCardOpinionProduct.vue')
);

const TsCarouselSale = defineAsyncComponent(
    () => import('~/components/organisms/TsCarouselSale.vue')
);

onMounted(() => {
  if (carouselBlackFridayRef.value) {
    observeElement(carouselBlackFridayRef.value)
  }
});

let observer;

const observeElement = (element) => {
  observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      fetchItems()
    }
  })
  observer.observe(element)
};

const fetchItems = async () => {
  // Replace with your actual fetch request
  if(!props.product_ids) return;
  const data_ids = props.product_ids?.split?.(',').map(item => +item)
  products.value = await new ProductService().getProducts(data_ids,true);
  logViewItemList(products.value)//gtm view_item_list
  if (observer && carouselBlackFridayRef.value) {
    observer.unobserve(carouselBlackFridayRef.value)
  }
}

type Data = {
    id: number,
    off_percentage: string;
    image: string;
    title: string;
    price: string;
    discount_price: string;
}


type Props = {
    product_ids?: string;
    background?: { desktopBannerImage: string, mobileBannerImage: string };
}

const props = withDefaults(defineProps<Props>(), {
    product_ids: '21360, 98124, 40207, 11112, 99532, 98882, 55338, 77195, 64025  ',
    background: () => ({ desktopBannerImage: '/images/black-friday.webp', mobileBannerImage: '/images/black-friday-mobile.webp' })
})

watchEffect(async () => {
    try {
      // fetchItems();
    } catch (error) {
        useErrorHandler(error, "critical")
    }
})

onUnmounted(() => {
  if (observer && carouselBlackFridayRef.value) {
    observer.unobserve(carouselBlackFridayRef.value)
  }
})
</script>